import { iconNames, iconSizes } from '@/components/shared';
import { Icon } from './Icon';
import register from './register';

register(Icon, {
	iconNames: iconNames,
	iconSizes: iconSizes,
	defaultIconName: 'group',
	defaultIconSize: 'md',
});
